import { create } from "zustand";
import type { ContentType } from "@/shared/gql/graphql";
import { track, trackedContentType } from "@/shared/lib/analytics";

type UpgradeDialogState = {
  feature: string | null;
  companySlug: string | null;
};

type UpgradeDialogActions = {
  openUpgradeDialog: (feature: string, companySlug: string) => void;
  closeUpgradeDialog: () => void;
};

export const useUpgradeDialogStore = create<
  UpgradeDialogState & UpgradeDialogActions
>((set) => ({
  feature: null,
  companySlug: null,
  openUpgradeDialog: (feature, companySlug) => set({ feature, companySlug }),
  closeUpgradeDialog: () => set({ feature: null, companySlug: null }),
}));

export const openUpgradeDialog = (
  feature: string,
  companySlug: string,
  contentType?: ContentType,
) => {
  // A batch of queries can report the same subscription_required error several
  // times: only the first opening for a feature is a paywall hit.
  if (useUpgradeDialogStore.getState().feature !== feature) {
    track("billing.paywall.hit", {
      feature,
      content_type: trackedContentType(contentType),
    });
  }
  useUpgradeDialogStore.getState().openUpgradeDialog(feature, companySlug);
};
